<template>
  <div class="page-content">

    <skeleton-list v-if="pageLoadingShow"/>
    <div v-else class="campus-offers-container">
      <cube-sticky :pos="scrollY" @change="stickyChange">
        <cube-scroll @scroll="scrollHandler" :scroll-events="scrollEvents" ref="pageScroll"
                     :options="options" @pulling-up="onPullingUp" @pulling-down="onPullingDown" :data="listDataMap.get(tag)">
          <div class="head-images-content">
            <cube-slide :data="headImages" :options="{ click: false }">
              <cube-slide-item v-for="(item, index) in headImages" :key="index">
                <div class="head-image-container flex-center">
                  <img @click="toBannerDetail(item)" class="head-image-item" :src="item.image" alt="">
                </div>
              </cube-slide-item>
              <template slot="dots" slot-scope="props">
              <span class="my-dot" :class="{'active': props.current === index}"
                    v-for="(item, index) in headImages.length" :key="index"></span>
              </template>
            </cube-slide>
          </div>
          <cube-sticky-ele>
            <div class="campus-offers-recommend flex-between">
              <div class="campus-offers-tags flex">
                <span class="tag-item" :class="{'tag-active flex-column-center': tag === 'recommend'}" @click="changeTagItem('recommend')">最新</span>
                <span class="tag-item" :class="{'tag-active flex-column-center': tag === 'hot'}" @click="changeTagItem('hot')">热门</span>
              </div>
              <div class="campus-offers-filters flex">
                <div class="flex-start filters-item" @click="pickFilterValue('city')">
                  <span :class="{ 'filter-active': !!pickCityData.city_id }">{{ pickCityData.city_name || '城市' }}</span>
                  <i class="iconfont iconRectangle-copy" :class="{'filter-content-active': filterValue === 'city'}"/>
                </div>
                <div class="flex-start filters-item" @click="pickFilterValue('profession')">
                  <span :class="{ 'filter-active': !!pickProfessionData.code || infoType !== '不限' }">行业</span>
                  <i class="iconfont iconRectangle-copy" :class="{'filter-content-active': filterValue === 'profession' || infoType !== '不限'}"/>
                </div>
              </div>
              <filter-city v-show="filterValue === 'city'" :city-data="cityData" :filter-value="filterValue" @changeCityCode="changeCityCode"/>
              <filter-profession v-show="filterValue === 'profession'" :filter-value="filterValue" @changeProfessionCode="changeProfessionCode" @changeInfoType="changeInfoType" />
            </div>
            <div v-if="filterValue" class="pick-filter-layer" @click="pickFilterValue('')"/>
          </cube-sticky-ele>
          <offers-list :offers-data="listDataMap.get(tag)" @changeCompanyName="changeCompanyName" @changeAttentionState="changeAttentionState" :type="tag" :ad-info="adCard"/>
          <w-more-loading v-if="pageDataMap.get(tag) < pageCountDataMap.get(tag) && alreadyLogged"/>
          <w-no-more v-if="pageDataMap.get(tag) >= pageCountDataMap.get(tag) && alreadyLogged" />
          <un-login v-if="!alreadyLogged"/>
        </cube-scroll>
      </cube-sticky>
    </div>
    <attention-dialog :clock-flag="clockFlag" :company-name="companyName" :dialog-state="attentionState" @handleClose="changeAttentionState" @toCampusManage="toCampusManage" />
  </div>
</template>

<script>
  import offersList from '../../components/job-list'
  import filterCity from '../../components/filter-city'
  import filterProfession from '../../components/filter-profession'
  import WNoMore from '../../../../components/global/w-no-more'
  import WMoreLoading from '../../../../components/global/w-more-loading'
  import skeletonList from '../../components/skeleton-list'
  import UnLogin from "../../components/unlogin"
  import {componentsMixin} from "../../../../assets/js/mixin/components";
  import {envMixin, loginMixin} from "../../../../assets/js/mixin/global";
  import {campusOfferMixin} from "../../../../assets/js/mixin/jobs";
  import {userMixin} from "../../../../assets/js/mixin/user";
  export default {
    name: 'job-campus-offers',
    mixins: [ componentsMixin, loginMixin, userMixin, envMixin, campusOfferMixin ],
    data() {
      return {
        scrollY: 0,
        scrollEvents: ['scroll'],
        tag: 'recommend', // 当前显示的列表数据
        filterValue: '', // 筛选显示
        headImages: [], // banner图片数组
        pickProfessionData: {}, // 筛选的profession的数据
        pickCityData: {}, // 筛选城市数据
        cityData: {}, // 城市数据
        options: {
          pullDownRefresh: {
            txt: '刷新成功'
          },
          pullUpLoad: true,
        }, //scroll的配置
        listDataMap: new Map([[ 'recommend', [] ], [ 'hot', [] ]]), // 列表数据的map
        pageCountDataMap: new Map([[ 'recommend', 0], [ 'hot', 0]]), // 总页数的map集合
        pageDataMap: new Map([[ 'recommend', 1], [ 'hot', 1]]), // 当前页数的map集合
        scrollDataMap: new Map([[ 'recommend', 0], [ 'hot', 0]]),
        isSticky: false,
        pageLoadingShow: true,
        headImageContentHeight: 0,
        infoType: '不限',
        adCard: null,
        clockFlag: false, // 闹钟提醒是否开启
        completed: false
      }
    },
    beforeRouteEnter(to, from, next) {
      document.title = '名企校招日历'
      next()
    },
    created () {
      this.getApplication()
    },
    async mounted() {
      await this.loginByWx()
      this.getBannerImage()
      this.getUserAccountData()
      this.getCampusOffersList({ type: 'recommend' })
      this.getCampusOffersList({ init: true })
      this.$route.meta.shareByWx('名企精英都在用的的智能工具，收藏查看各大行业和公司动态，全网最新名企网申信息，让找工作的成功率翻倍！', { title: '实时更新｜ 21届大厂校招内推信息' })
      this.onShareMessage()
      let {query} = this.$route
      if(query.captain_token && !this.alreadyLogged){
        this.needLogin()
      }else if(query.captain_token && this.alreadyLogged){
        let new_account = this.$db.ls.get('offers_new_account')
        if(new_account){
         try {
           await this.$api.jobs.joinTeam(query.captain_token)
         }catch (e) {
         }
          this.$db.ls.remove("offers_new_account")
        }
      }
    },
    computed: {},
    watch: {},
    components: {
      offersList,
      filterCity,
      filterProfession,
      skeletonList,
      WNoMore,
      WMoreLoading,
      UnLogin
    },
    methods: {
      async getApplication () {
				let res = await this.$api.jobs.getNetApplication()
				if (res.code === 1000) {
					this.clockFlag = res.data.wechat_all_net_application_status
				}
			},
      onShareMessage() {
        try {
          setTimeout(() => {
            this.$wechat.miniProgram.postMessage({
              data: {
                title: '实时更新｜ 21届大厂校招内推信息',
                description: '名企精英都在用的的智能工具，收藏查看各大行业和公司动态，全网最新名企网申信息，让找工作的成功率翻倍！'
              }
            })
          }, 1500)
        } catch (e) {
          console.log(e)
        }
      },
      // 列表上拉
      onPullingUp() {
        if(!this.alreadyLogged) return;
        let page = this.pageDataMap.get(this.tag)
        let pageCount = this.pageCountDataMap.get(this.tag)
        if (page < pageCount) {
          this.pageDataMap.set(this.tag, page + 1)
          this.getCampusOffersList()
        }
      },
      // 列表下拉刷新
      onPullingDown() {
        this.refreshPagePayload()
        this.getBannerImage()
        this.getCampusOffersList({ type: 'recommend', refresh: true })
        this.getCampusOffersList({ type: 'hot', refresh: true })
      },
      // 选择行业code
      changeProfessionCode(item) {
        this.filterValue = ''
        if (item.code !== this.pickProfessionData.code) {
          this.pickProfessionData = item
          this.refreshPagePayload()
          this.$refs.pageScroll.scrollTo(0, -this.headImageContentHeight)
          this.getCampusOffersList({ type: 'recommend' })
          this.getCampusOffersList({ type: 'hot' })
        }
      },
      // 选择校招类型
      changeInfoType(item) {
        this.filterValue = ''
        if (item.text !== this.infoType) {
          this.infoType = item.text
          this.refreshPagePayload()
          this.$refs.pageScroll.scrollTo(0, -this.headImageContentHeight)
          this.getCampusOffersList({ type: 'recommend' })
          this.getCampusOffersList({ type: 'hot' })
        }
      },
      // 选择城市code
      changeCityCode(value) {
        this.filterValue = ''
        if (value.city_id !== this.pickCityData.city_id) {
          this.pickCityData = value.city_id ? value : {}
          this.refreshPagePayload()
          this.$refs.pageScroll.scrollTo(0, -this.headImageContentHeight)
          this.getCampusOffersList({ type: 'recommend' })
          this.getCampusOffersList({ type: 'hot' })
        }
      },
      refreshPagePayload() {
        this.pageDataMap.set('recommend', 1)
        this.pageDataMap.set('hot', 1)
        this.scrollDataMap.set('recommend', -this.headImageContentHeight)
        this.scrollDataMap.set('hot', -this.headImageContentHeight)
      },
      // 滚动事件
      scrollHandler({ y }) {
        this.scrollY = -y
        // const type = this.tag === 'recommend' ? 'hot' : 'recommend'
        // if (-this.scrollDataMap.get(type) < 183 && -y < 183) {
        //   this.scrollDataMap.set(type, y)
        // }
        this.scrollDataMap.set(this.tag, y)
      },
      // 切换列表tag
      changeTagItem(tagItem) {
        this.tag = tagItem
        let data = this.listDataMap.get(this.tag)
        if (data && data.length) {
          let y = this.scrollDataMap.get(this.tag)
          const scrollY = this.headImages.length && this.isSticky && -y < this.headImageContentHeight ? y - this.headImageContentHeight : y
          this.$refs.pageScroll.scrollTo(0, scrollY)
        } else {
          this.getCampusOffersList()
        }
      },
      // 显示筛选项的值
      pickFilterValue(value) {
        if (value === this.filterValue) {
          this.filterValue = ''
        } else {
          const el = document.querySelector('.head-images-content')
          if (this.scrollY < el.clientHeight) {
            this.$refs.pageScroll.scrollTo(0, -el.clientHeight, 300)
          }
          this.filterValue = value
        }
      },
      // 获取筛选的城市数据和行业的数据
      getFilterData() {
        this.$api.HrApi.getObtainCity().then(res => {
          if (res.code === 1000) {
            this.cityData = res.data
          }
        }) .catch(e => console.log(e))
      },
      // 获取校招列表的接口
      getCampusOffersList(params = {}) {
        let page = this.pageDataMap.get(this.tag)
        let payload = {
          page,
          size: 10,
          city_id: this.pickCityData.city_id,
          category: this.pickProfessionData.code,
          info_type: this.infoType
        }
        payload.type = params.type || this.tag
        this.$api.campusOffers.getCampusOfferList(payload).then(res => {
          if (res.code === 1000) {
            let list = this.listDataMap.get(payload.type)
            if(res.data.top_comp_recruit_infos !== null && res.data.top_comp_recruit_infos !== 'null'){
              this.listDataMap.set(payload.type, page === 1 ? [...res.data.top_comp_recruit_infos,...res.data.comp_recruit_infos] : [...res.data.top_comp_recruit_infos, ...list, ...res.data.comp_recruit_infos ])
            }else{
              this.listDataMap.set(payload.type, page === 1 ? [...res.data.comp_recruit_infos] : [ ...list, ...res.data.comp_recruit_infos ])
            }
            //去重
            var obj = {}
            this.listDataMap.set(payload.type,
              (this.listDataMap.get(this.tag).reduce(function (item, next) {
                obj[next.token] ? '' : obj[next.token] = true && item.push(next);
                return item;
              }, []))
            )
            this.pageCountDataMap.set(payload.type, res.data.page_count)
            // pageLoadingShow之后再调城市接口，防止组件watch触发之后，dom因为v-if的关系没有渲染
            if (params.init) {
              this.getFilterData()
              this.pageLoadingShow = false
            }
            this.$nextTick(() => {
              const el = document.querySelector('.head-images-content')
              this.headImageContentHeight = el ? el.clientHeight : 0
            })
            // 拿到的当前tag的数据不满一屏幕时页面滚动到最上面位置
            if (page === 1 && res.data.page_count === 1 && this.listDataMap.get(this.tag).length < 6) {
              this.$refs.pageScroll && this.$refs.pageScroll.scrollTo(0, 0)
            }
            this.$forceUpdate()
          } else {
            this.showToast('服务器开小差了，请稍后再试')
          }
        }).catch(e => console.log(e))
      },
      // 获取banner数据
      getBannerImage() {
        this.$api.jobs.getBannerImg({position: 14}).then(res => {
          if (res.code === 1000) {
            this.headImages = res.data
            // this.$refs.pageScroll.refresh()
          } else {
            this.headImages = []
          }
        }).catch(e => {
          this.headImages = []
        })
        this.$api.jobs.getBannerImg({position: 23}).then(res => {
          if (res.code === 1000) {
            this.adCard = res.data.length > 0 ? res.data[0] : null
            // this.$refs.pageScroll.refresh()
          } else {
            this.adCard = null
          }
        }).catch(e => {
          this.adCard = null
        })
      },
      // 获取用户数据
      getUserAccountData() {
        let keys = Object.keys(this.userData || {})
        if (keys && !keys.length && this.alreadyLogged) {
          this.getUserData()
        }
      },
      // banner跳转
      toBannerDetail(item) {
        if (item.link) {
          if (this.isWxMini) {
            this.$wechat.miniProgram.navigateTo({
              url: `/pages/freeUrl/freeUrl?url=${item.link}`
            })
          } else {
            window.location.href = item.link
          }
        }
      },
      // 吸附元素改变时
      stickyChange(current, index) {
        this.isSticky = !!!index;
      },
      //查看是否完成裂变
      async getTeamInfo(){
        try{
          let res = await this.$api.jobs.getTeamInfo()
          if(res.code === 1000){
            this.completed = res.data.completed
            this.$db.ls.set('completed', res.data.completed)
          }
        }catch (e) {

        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/scss/global/variable";
  @import "../../../../assets/scss/global/mixin";
  .campus-offers-container {
    height: $screen-height;
    @include mobile-container(0, 1px);
    .head-images-content {
      .head-image-container {
        width: 100vw;
        box-sizing: border-box;
        padding: 12px 0;
        .head-image-item {
          height: 136px;
          border-radius: 6px;
          width: calc(100vw - 32px);
          object-fit: cover;
        }
      }
      ::v-deep .cube-slide-dots {
        padding-bottom: 18px;
        .my-dot {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #C4C4C6;
          margin-right: 6px;
          /*padding-bottom: 6px;*/
          &:last-child {
            margin-right: 0;
          }
        }
        .active {
          background-color: $color-light;
        }
      }
    }
    .campus-offers-recommend {
      padding: 8px 16px;
      background-color: $color-light;
      width: 100%;
      position: relative;
      z-index: 10;
      .campus-offers-tags {
        .tag-item {
          color: #9C9C9C;
          font-size: $font-size-medium-x;
          margin-right: 24px;
          line-height: 22px;
          &:last-child {
            margin-right: 0;
          }
        }
        .tag-active {
          color: $color-title;
          font-weight: 500;
          // margin-top: -4px;
          &::after {
            content: '';
            width: 16px;
            height: 3px;
            border-radius: 1.5px;
            background-color: $color-theme;
            margin-top: 4px;
          }
        }
      }
      .campus-offers-filters {
        margin-bottom: 7px;
        .filters-item {
          color: $color-dark-gray;
          font-size: $font-size-medium-x;
          line-height: 22px;
          font-weight: 500;
          &:first-child {
            margin-right: 24px;
          }
          i {
            transition: all .3s;
            transform: rotate(0);
            margin-left: 5px;
            font-size: 12px;
            color: #BCBCBC;
          }
          .filter-content-active {
            transform: rotate(180deg);
          }
          .filter-active {
            color: $color-theme;
          }
        }
      }
      .filter-city-container, .filter-profession-container {
        position: absolute;
        top: 44px;
        left: 0;
      }
    }
    .pick-filter-layer {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($color: #000, $alpha: .5);
      z-index: 9;
    }
    ::v-deep .cube-pulldown-loaded {
      color: #9c9c9c;
    }
  }
</style>
